import type { TransactionDetail } from '../schemas/transactionDetail'
import type { TokenAccountMap } from './types'

export const createTokenAccounts = (
  transaction: TransactionDetail,
): TokenAccountMap => {
  const mut_tokenAccounts: {
    [address: string]:
      | {
          readonly mint: string
          readonly owner: string | undefined
        }
      | undefined
  } = {}
  for (const tokenBalance of [
    ...(transaction.meta?.postTokenBalances ?? []),
    ...(transaction.meta?.preTokenBalances ?? []),
  ]) {
    const address =
      transaction.transaction.message.accountKeys[tokenBalance.accountIndex]
        .pubkey
    if (mut_tokenAccounts[address] === undefined) {
      mut_tokenAccounts[address] = {
        mint: tokenBalance.mint,
        owner: tokenBalance.owner,
      }
    }
  }
  return mut_tokenAccounts
}
